import { colors } from 'configs'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  spinner: {
    color: colors?.risikaContrast,
  },
}))
